// extracted by mini-css-extract-plugin
export default {"borderedCard":"BorderedCard_borderedCard__59pKW"};